import type { GeneratableDocumentWorkflowTemplateType } from '@dealstack/prisma-client';

export enum GeneratableDocumentVersion {
	INDIVIDUAL = 'INDIVIDUAL',
	PIV = 'PIV',
}

export enum FilePreviewMode {
	SMART_FIELDS = 'smartFields',
	MOCKED_DATA = 'mockedData',
}

export const AVAILABLE_VERSION_BY_TEMPLATE_TYPE: Record<
	GeneratableDocumentWorkflowTemplateType,
	GeneratableDocumentVersion[]
> = {
	GDPR_NOTICE: [GeneratableDocumentVersion.INDIVIDUAL, GeneratableDocumentVersion.PIV],
	ANNUAL_STATEMENT: [GeneratableDocumentVersion.INDIVIDUAL],
	FORM_S431: [GeneratableDocumentVersion.INDIVIDUAL],
};
